// extracted by mini-css-extract-plugin
export default {"container":"EditorContainer_container__4fkw+","loading":"EditorContainer_loading__cXEiz","spinner":"EditorContainer_spinner__o4zr-","spin":"EditorContainer_spin__9xSdJ"};